export function handleFormDataWithObject(obj, formData) {
  Object.keys(obj).forEach((key) => {
    formData.append(key, Array.isArray(obj[key]) ? JSON.stringify(obj[key]) : obj[key]);
  });
}
